import React from 'react';

export default function SharedIncidentList() {
    return <div></div>;
}
